import React from 'react';

const DividerComponent = () => {
  return <div className="divider-component" />;
};

export default DividerComponent;
